import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  CLIENT_RESULTS_COUNT,
  MODELS,
} from 'src/components/Search/constants';
import SearchBarSection from './SearchBarSection';

const SearchBarResults = (props, context) => {
  const { clientIdStandardizationEnabled, medicaidFilteringEnabled } = context;
  const showWideSearchResults = clientIdStandardizationEnabled || medicaidFilteringEnabled;

  return (
    <div className={classNames(
      'search-results',
      {
        'max-w-3xl': !showWideSearchResults,
        'max-w-4xl': showWideSearchResults,
      },
    )}
    >
      <SearchBarSection
        displayName="Clients"
        model={MODELS.contact}
        numResults={CLIENT_RESULTS_COUNT}
        scope={props.scope}
      />
    </div>
  );
};

SearchBarResults.propTypes = {
  scope: PropTypes.string.isRequired,
};

SearchBarResults.contextTypes = {
  clientIdStandardizationEnabled: PropTypes.bool.isRequired,
};

export default SearchBarResults;
